import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigurationService } from '@pflegix/config';
import {
  IDocumentationV2,
  INoventiAdminActionSummary,
  MessageCode,
  MessageSeverity,
  NoventiRecordType,
} from '@pflegix/types';
import { Observable } from 'rxjs';

export type ExportDocumentationResult = {
  type: NoventiRecordType;
  resultState: MessageSeverity;
  resultMessageCode: MessageCode;
  resultMessage: string;
  resultMessageDetails: string;
};

@Injectable({ providedIn: 'root' })
export class DocumentationExportApi {
  private readonly httpClient = inject(HttpClient);
  private readonly configurationService = inject(ConfigurationService);

  public exportDocumentationById(documentationId: IDocumentationV2['_id']): Observable<ExportDocumentationResult[]> {
    return this.httpClient.post<ExportDocumentationResult[]>(
      `${this.apiUrl}/export-documentation/${documentationId}`,
      {}
    );
  }

  public exportDocumentations(startAt: Date, endAt: Date): Observable<INoventiAdminActionSummary> {
    const queryParams = new HttpParams().set('startAt', startAt.toISOString()).set('endAt', endAt.toISOString());

    return this.httpClient.get<INoventiAdminActionSummary>(`${this.apiUrl}/export-documentations`, {
      params: queryParams,
    });
  }

  public getSummaryOfLatestDocumentationsExport(): Observable<INoventiAdminActionSummary> {
    return this.httpClient.get<INoventiAdminActionSummary>(`${this.apiUrl}/export-documentations/get-latest-summary`);
  }

  public downloadLatestDocumentationsExportResult(): Observable<string> {
    return this.httpClient.get(`${this.apiUrl}/export-documentations/download-latest-result`, {
      responseType: 'text',
    });
  }

  private get apiUrl(): string {
    return `${this.configurationService.get('basePflegixApiUrl')}/api/noventi-admin`;
  }
}
